// One-click periods for the pivot. Dates are local calendar days, formatted
// like the date pickers (YYYY-MM-DD); `null` bounds mean "no limit".
export interface PivotPeriod {
  from: string | null;
  to: string | null;
}

export interface PivotPeriodPreset {
  key: string;
  label: string;
  range: (today: Date) => PivotPeriod;
}

const iso = (d: Date) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const shift = (d: Date, days: number) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + days);

export const PIVOT_PERIOD_PRESETS: PivotPeriodPreset[] = [
  { key: "today", label: "Today", range: (t) => ({ from: iso(t), to: iso(t) }) },
  { key: "yesterday", label: "Yesterday", range: (t) => ({ from: iso(shift(t, -1)), to: iso(shift(t, -1)) }) },
  { key: "last_7", label: "Last 7 days", range: (t) => ({ from: iso(shift(t, -6)), to: iso(t) }) },
  { key: "last_30", label: "Last 30 days", range: (t) => ({ from: iso(shift(t, -29)), to: iso(t) }) },
  { key: "this_year", label: "This year", range: (t) => ({ from: iso(new Date(t.getFullYear(), 0, 1)), to: iso(t) }) },
  { key: "all", label: "All time", range: () => ({ from: null, to: null }) },
];

// The preset whose range is exactly the current one, if any — so the chip reads as active.
export const activePresetKey = (period: PivotPeriod, today = new Date()): string | null =>
  PIVOT_PERIOD_PRESETS.find((p) => {
    const r = p.range(today);
    return r.from === period.from && r.to === period.to;
  })?.key ?? null;
